import AddStudent from './add-student';
export default AddStudent;
